import { useEffect, useRef } from "react";
import { createGameEngine } from "./game-loop.js";

function PiRunnerGame() {

    const canvasRef = useRef(null);

    // Load font
    useEffect(() => {
        const font = new FontFace('EditUndo', 'url(/fonts/editundo.ttf)');
        font.load().then(() => {
            document.fonts.add(font);
        }).catch((error) => {
            console.error('Failed to load font: ', error);
        }

        )
    }, []);
    
    useEffect(() => {
        const canvas = canvasRef.current;
        const gameEngine = createGameEngine(canvas);
        gameEngine.start();

        const handleKeyDown = (e) => {
            gameEngine.handleKeyPress(e.key);
        }
        window.addEventListener('keydown', handleKeyDown);

        return () => {
            window.removeEventListener('keydown', handleKeyDown);
            gameEngine.stop();
        };
    }, []);

    return (
        <canvas ref={canvasRef} width="1000" height="600"/>
    );
}

export default PiRunnerGame;